<template>
	<div class="page">
		<div class="searchBlock">
			<!-- <el-select v-model="keyword" placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select> -->
			<el-input style="margin-left: 10px;flex:2" placeholder="请输入内容" v-model="message" class="input-with-select">
				<el-button slot="prepend" icon="el-icon-search" @click="getList"></el-button>
				<el-button slot="append" type="info" @click="reset">重置</el-button>
			</el-input>
			<!-- <el-date-picker style="margin-right: 10px;" v-model="time" format="yyyy-MM-dd" type="datetimerange"
				:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
				align="right" /> -->
		</div>

		<div class="table">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" min-width="55">
				</el-table-column>
				<el-table-column fixed prop="username" label="姓名" min-width="100">
				</el-table-column>
				<el-table-column prop="user_id" label="用户ID" min-width="120">
				</el-table-column>
				<el-table-column prop="sender_nickname" label="发送人" min-width="120">
				</el-table-column>
				<!-- <el-table-column prop="sender_nickname" label="发送人" min-width="120">
				</el-table-column> -->
				<el-table-column prop="message_type" label="消息类型" min-width="80">
				</el-table-column>
				<el-table-column prop="message" label="消息内容" min-width="320">
				</el-table-column>
				<el-table-column prop="createtime" label="创建时间" min-width="300">
				</el-table-column>
				<el-table-column fixed="right" label="操作" min-width="120">
					<template>
						<!-- slot-scope="scope" -->
						<!-- @click.native.prevent="deleteRow(scope.$index, tableData)" -->
						<el-button type="text" @click="drawer = true" size="small">
							详情
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<div class="searchBlock bottomFy">
			<!-- @size-change="handleSizeChange" @current-change="handleCurrentChange" -->
			<el-pagination 
				:current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10"
				layout="total,  sizes" :total="total">
			</el-pagination>
			<div class="page-wrapper">
				<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>
			
				<div class="page-input">
					<el-input style="width: 70px;margin-right: 10px;" type="number" v-model.number="inputPage" @keyup.enter="jumpPage"></el-input>
					<span>/ {{ totalPage }}</span>
				</div>
			
				<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
			</div>
		</div>
		
		<rightDrawer :drawer="drawer" :params="drawerObj" @update:drawer="drawer = $event"></rightDrawer>
	</div>
</template>

<script>
	import rightDrawer from './rightDrawer'
	export default {
		components: {
			rightDrawer,
		},
		data() {
			return {
				drawer:false,
				options: [{
						label: '成员',
						value: 'menber'
					},
					{
						label: '会话',
						value: 'chat'
					}
				],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				time: '',

				tabIndex: 'activeChat',

				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 0,
				totalPage: 0,
				tableData: [],
				selection: [],
				keyword: '',
				drawerObj: {},
				message: '',
			}
		},
		methods: {
			tabChange(item) {
				this.tabIndex = item.type
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			reset() {
				this.message = ''
				this.getList()
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getChatLogList, {
					page: this.page,
					limit: this.pageSize,
					message: this.message
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
		},
		// mounted() {
		// 	this.getList()
		// }
	}
</script>

<style lang="scss" scoped>
	.page {
		height: 95%;

		.searchBlock {
			display: flex;
			align-content: center;
		}
		
		.table{
			margin: 10px 0 ;
		}
		
		.bottomFy{
			margin-top: 10px;
			
			.page-wrapper{
				display: flex;
				align-items: center;
				/* height: 80%; */
				
				.page-input{
					margin: 0px 10px;
					display: flex;
					align-items: center;
				}
			}
		}
	}
</style>